import { ProfileApi } from "../../api/ProfileApi"
import { getSid } from "./AuthReducer";
import { AuthHelper } from "../../helpers/AuthHelper";
import { errorToast, successToast } from "../../utils/Toasts";
import { ApiErrorHandler } from '../../api/ApiErrorHandler';

const SET_USER_PROFILE = 'SET_USER_PROFILE';

const initialState = {
    data: null,
    errors: null,
    status: null
}

const ProfileReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_USER_PROFILE: {
            return {
                ...state,
                data: action.profile
            }
        }

        default: {
            return state
        }
    }
}

export const setProfile = (profile) => ({
    type: SET_USER_PROFILE, profile
})

export const setPassword = (profile) => ({
    type: SET_USER_PROFILE, profile
})

export const getUserProfile = (sid) => {
    return (
        (dispatch) => {
            ProfileApi.getProfile(sid)
                .then(data => {
                    if (data.status === 'ok') {
                        dispatch(setProfile(data))
                    } else {
                        if (data.errors[0].name === "WrongSIDException") {
                            Promise.all([
                                dispatch(getSid())
                            ]).then(() => {
                                dispatch(getUserProfile(AuthHelper.getSid()))
                            })
                        }
                    }
                })
				.catch(e => ApiErrorHandler(e))
        }
    )
}

export const setUserProfile = (params) => {
    let param = params
    return (
        (dispatch) => {
            ProfileApi.setProfile(param)
                .then(data => {
                    if (data.status === 'ok') {
                        successToast("Данные успешно сохранены");
                    } else {
                        const errors = data.errors;
                        if (errors[0].name === "WrongSIDException") {
                            param.delete('sid')
                            Promise.all([
								dispatch(getSid())
							]).then(() => {
                                param.append('sid', AuthHelper.getSid());
                                dispatch(setProfile(param))
                            })
                        }

                        if (errors.length > 0) {
                            errors.forEach((error) => {
                                for (let key in error) {
                                    error[key].forEach((message) => errorToast(message))
                                }
                            })
                        }

                    }
                })
				.then(dispatch(getUserProfile(AuthHelper.getSid())))
				.catch(e => ApiErrorHandler(e))
        }
    )
}

export const changePassword = (params) => {
    let param = params
    return (
        (dispatch) => {
            ProfileApi.setNewPassword(param)
                .then(data => {
                    if (data.status === 'ok') {
                        successToast("Пароль успешно изменен")
                    } else {
                        if (data.errors[0].name === "WrongSIDException") {
                            params.delete('sid')
                            let promiseGetSid = dispatch(getSid())
                            Promise.all([promiseGetSid]).then(() => {
                                param.append('sid', AuthHelper.getSid());
                                dispatch(setPassword(param))
                            })
                        }
                    }
                })
				.then(AuthHelper.setCurrentUserPassword(param.get('password')))
				.catch(e => ApiErrorHandler(e))
        }
    )
}

export default ProfileReducer
